/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Add_ConditionInputs */

const cs_automation_add_condition = /** @type {(inputs: Automation_Add_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat podmínku`)
};

const en_automation_add_condition = /** @type {(inputs: Automation_Add_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add condition`)
};

/**
* | output |
* | --- |
* | "Add condition" |
*
* @param {Automation_Add_ConditionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_add_condition = /** @type {((inputs?: Automation_Add_ConditionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Add_ConditionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_add_condition(inputs)
	return cs_automation_add_condition(inputs)
});